import qs from 'qs';
import api from '@/services/ApiService';
import useDataStore from '@/store/data';
import { useEffect, useState, useCallback } from 'react';

export default function useApiQuery(
  schemaName,
  constFilters = {},
  active = false,
) {
  const { upsert, schemas, resetCollection } = useDataStore();
  const [isPending, setIsPending] = useState(false);
  const [error, setError] = useState(null);
  const [total, setTotal] = useState(0);

  const schema = schemas[schemaName];

  const data = Object.values(
    useDataStore((state) => state[schema.collection]) || {},
  );

  const fetchData = useCallback(
    async (filters = {}) => {
      setIsPending(true);
      let fetchedTotal = 0;
      let result;
      try {
        const queryString = `${qs.stringify(constFilters)}&${qs.stringify(filters)}`;
        const { data: responseData } = await api.get(
          `${schemaName}?${queryString}`,
        );

        if (Array.isArray(responseData.result)) {
          if (
            responseData.result.length === 0 ||
            responseData?.result === null
          ) {
            resetCollection(schema.collection);
          } else {
            responseData.result.forEach((item) => upsert(item));
          }
        } else {
          upsert(responseData);
        }

        result = responseData.result.map((item) => item._id);
        fetchedTotal = responseData.total;
        setTotal(fetchedTotal);
      } catch (err) {
        setError(err);
      } finally {
        setIsPending(false);
      }
      return { total: fetchedTotal, isPending, error, result };
    },
    [schemaName, constFilters, upsert],
  );

  useEffect(() => {
    if (active) {
      fetchData();
    }
  }, [active]);

  const revalidate = useCallback((filters) => fetchData(filters), [fetchData]);
  const refetch = useCallback((filters) => fetchData(filters), [fetchData]);

  return { data, isPending, error, total, revalidate, refetch, fetchData };
}
